module.exports = __webpack_public_path__ + "img/IT0000841240563.10494336.png";